import { Link } from "@/lib/router-compat";
import Layout from "@/components/Layout";

interface NotFoundProps {
  hubPath?: string;
  hubLabel?: string;
}

const NotFound = ({ hubPath, hubLabel }: NotFoundProps) => {
  return (
    <Layout>
      <div className="flex min-h-[60vh] items-center justify-center bg-charcoal text-charcoal-foreground">
        <div className="text-center max-w-xl px-4">
          <p className="mb-3 font-condensed text-[13px] font-bold uppercase text-primary-light">Page not found</p>
          <h1 className="mb-4 text-5xl font-heading font-bold text-charcoal-foreground">404 — Page Not Found</h1>
          <p className="mb-6 text-lg text-charcoal-foreground/70 font-body">
            Sorry, the page you're looking for doesn't exist or has been moved. 
            Try one of the links below to find what you need.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
            {hubPath && hubLabel && (
              <Link to={hubPath} className="btn-primary px-6 py-3 text-base inline-flex items-center gap-2 justify-center">
                View {hubLabel}
              </Link>
            )}
            <Link to="/" className="btn-primary px-6 py-3 text-base inline-flex items-center gap-2 justify-center">
               Go to Homepage
            </Link>
            <Link to="/contact" className="btn-outline px-6 py-3 text-base inline-flex items-center gap-2 justify-center">
               Contact Us
            </Link>
          </div>
          <div className="space-y-2 font-body text-sm text-charcoal-foreground/70">
            <p className="font-semibold text-charcoal-foreground">Popular Pages:</p>
            <div className="flex flex-wrap gap-x-4 gap-y-1 justify-center">
              <Link to="/electrical-services" className="text-primary hover:underline">Electrical Services</Link>
              <Link to="/hvac-services" className="text-primary hover:underline">HVAC Services</Link>
              <Link to="/energy-management" className="text-primary hover:underline">Energy Management</Link>
              <Link to="/service-area" className="text-primary hover:underline">Service Areas</Link>
              <Link to="/blog" className="text-primary hover:underline">Blog</Link>
              <Link to="/request-estimate" className="text-primary hover:underline">Request Estimate</Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
